import React, { useCallback, useState } from 'react'
import { connect } from 'react-redux'
import { OrderCreateArgs, OrderActions, CollateralBasket } from 'api'
import { DialogRow, DialogField } from 'view/components/inputs'
import { Locale, Translation } from 'locale'
import { NotificationActions, ShowGrowlArgs } from 'store/notification'
import { FundComboboxField } from 'view/shared/entity'
import { DialogWindow } from 'view/components/panels/DialogWindow'

interface SelectFundDialogProps {
  onCreateOrder: (args: OrderCreateArgs) => unknown
  onShowGrowl: (growlArgs: ShowGrowlArgs) => unknown
  collateralBasket: CollateralBasket
  onClose?: () => unknown
  onStageBasketOrder: (basketId: string, fundId: string) => void
}

const mapStateToProps = null

const mapDispatchToProps = {
  onCreateOrder: OrderActions.create,
  onShowGrowl: NotificationActions.showGrowl
}

const SelectFundDialogComponent: React.FunctionComponent<SelectFundDialogProps> = props => {
  const { collateralBasket, onClose, onStageBasketOrder } = props
  const [fundId, setFundId] = useState<string | null>(null)

  const stageBasketOrder = useCallback(() => {
    if (!fundId) {
      return
    }

    onStageBasketOrder(collateralBasket.id, fundId)

    if (onClose) {
      onClose()
    }
  }, [fundId, onStageBasketOrder, collateralBasket.id, onClose])

  return (
    <DialogWindow
      title={Translation.TC_STAGE_NEW_BASKET_ORDER}
      titleArgs={{ basketName: collateralBasket.name }}
      confirmButtonEnabled={!!fundId}
      onConfirm={stageBasketOrder}
      confirmLabel={Translation.TC_BUTTON_OK}
      onClose={onClose}>
      <DialogRow>
        <DialogField>
          <FundComboboxField
            label={Locale.translate(Translation.TC_FUND_LABEL)}
            placeholder={Locale.translate(Translation.SC_FUND_PLACEHOLDER)}
            value={fundId}
            instrumentId={collateralBasket.id}
            onUpdate={setFundId}
          />
        </DialogField>
      </DialogRow>
    </DialogWindow>
  )
}

export const SelectFundDialog = connect(mapStateToProps, mapDispatchToProps)(SelectFundDialogComponent)
